<div class="modal-content" ridangoAppTrapFocus>
    <div class="feedback-modal__header flex items-center justify-between p-4">
        <div class="flex items-center">
            <div class="feedback-icon mr-3">
                <img class="hide-for-wcag" alt="" src="./assets/logo-landing-page.png" />
                <img class="show-high-contrast-view" alt="" src="./assets/logo-wcag.png" />
            </div>
            <h1 class="text-xl font-bold">{{ 'FEEDBACK_MODAL_TITLE' | translate }}</h1>
        </div>
        <button class="feedback-modal-close-button" [attr.aria-label]="'CLOSE' | translate" (click)="decline()">
            <span class="close-icon">×</span>
        </button>
    </div>

    <div class="feedback-modal-text-content modal-scrollable-content p-4">
        <p class="mb-4">{{ 'FEEDBACK_MODAL_DESCRIPTION' | translate }}</p>
        <h2 class="mb-4 mt-6 font-bold">{{ 'FEEDBACK_MODAL_THANK_YOU' | translate }}</h2>
    </div>

    <div class="feedback-modal__actions flex justify-between gap-4 p-4">
        <button
            class="btn border-1 rounded-full border-solid py-2"
            [attr.aria-label]="'FEEDBACK_MODAL_DECLINE' | translate"
            (click)="decline()">
            {{ 'FEEDBACK_MODAL_DECLINE' | translate }}
        </button>
        <button
            class="btn border-1 rounded-full border-solid py-2"
            [attr.aria-label]="'FEEDBACK_MODAL_MAYBE_LATER' | translate"
            (click)="maybeLater()">
            {{ 'FEEDBACK_MODAL_MAYBE_LATER' | translate }}
        </button>
        <button
            class="btn flex items-center rounded-full py-2 text-white"
            [attr.aria-label]="'FEEDBACK_MODAL_PARTICIPATE' | translate"
            (click)="participate()">
            <span>{{ 'FEEDBACK_MODAL_PARTICIPATE' | translate }}</span>
            <span class="ml-2">→</span>
        </button>
    </div>
</div>
